<div class="main-content">
  <div class="container-fluid">

    <div *ngIf="loading" class="text-center" style="padding: 60px 0;">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>

    <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <ng-container *ngIf="!loading && application">

      <div class="page-header">
        <h3>
          {{ serviceTitle }}
          <span class="label" [ngClass]="statusBadgeClass" style="font-size:14px; vertical-align: middle; margin-left: 10px;">
            {{ statusLabel }}
          </span>
        </h3>
        <p class="text-muted">Submitted on {{ application.created_at | date:'d MMMM yyyy' }}</p>
      </div>

      <!-- ══════════════════════════════════════════════════════════════════════
           EPE VIEW
           ══════════════════════════════════════════════════════════════════════ -->
      <ng-container *ngIf="isEpe">

        <!-- OPEN CALL TOPICS -->
        <div class="view-section">
          <h4 class="view-section-title">Open Call Topics</h4>
          <div *ngIf="topicDetails.length > 0; else legacyTopics">
            <div *ngFor="let td of topicDetails" class="entry-panel panel panel-default">
              <div class="panel-heading"><strong>{{ td.label }}</strong></div>
              <div class="panel-body">
                <div class="view-field">
                  <label>Evidence of expertise</label>
                  <p>{{ td.evidence || '—' }}</p>
                </div>
                <div class="view-field">
                  <label>Primary type of support offered</label>
                  <div *ngIf="td.support.length > 0; else noSupport">
                    <span *ngFor="let s of td.support" class="topic-badge">{{ s }}</span>
                  </div>
                  <ng-template #noSupport><span class="text-muted">—</span></ng-template>
                </div>
              </div>
            </div>
          </div>
          <ng-template #legacyTopics>
            <div *ngIf="topicLabels.length > 0; else noTopics">
              <span *ngFor="let t of topicLabels" class="topic-badge">{{ t }}</span>
            </div>
            <ng-template #noTopics><span class="text-muted">—</span></ng-template>
          </ng-template>
        </div>

        <!-- STANDARDISATION ROLES -->
        <div class="view-section">
          <h4 class="view-section-title">Standardisation roles and evidence of participation</h4>
          <div class="view-field">
            <label>Do you have any experience or roles in standardisation?</label>
            <p>{{ formData.standardisation_experience === 'yes' ? 'Yes' : 'No' }}</p>
          </div>
          <ng-container *ngIf="formData.standardisation_experience === 'yes'">
            <div class="view-field">
              <label>Are you a member of an SDO?</label>
              <p>{{ formData.sdo_member === 'yes' ? 'Yes' : 'No' }}</p>
            </div>
            <ng-container *ngIf="formData.sdo_member === 'yes'">
              <div *ngIf="formData.standardisation_roles && formData.standardisation_roles.length > 0; else noRoles">
                <div *ngFor="let role of formData.standardisation_roles; let i = index" class="entry-panel panel panel-default">
                  <div class="panel-heading"><strong>Role {{ i + 1 }}</strong></div>
                  <div class="panel-body">
                    <div class="row">
                      <div class="col-md-8"><label>Standards development organisation / NSB / NC</label><p>{{ role.sdo || '—' }}</p></div>
                      <div class="col-md-4" *ngIf="role.other_sdo"><label>Other (specify)</label><p>{{ role.other_sdo }}</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-4"><label>Number of TC/SC/WG</label><p>{{ role.tc_number || '—' }}</p></div>
                      <div class="col-md-4"><label>Title of TC/SC/WG</label><p>{{ role.tc_title || '—' }}</p></div>
                    </div>
                    <div class="row">
                      <div class="col-md-6"><label>Role(s)</label><p>{{ role.roles || '—' }}</p></div>
                      <div class="col-md-3"><label>Years of Experience</label><p>{{ role.years_of_experience || '—' }}</p></div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noRoles><span class="text-muted">No roles provided.</span></ng-template>
            </ng-container>
          </ng-container>
        </div>

        <!-- Q3 — EXPLAIN YOUR FIT -->
        <div class="view-section">
          <h4 class="view-section-title">Explain your fit with HSbooster.eu II services</h4>
          <div class="view-field">
            <label>Standardisation support approach</label>
            <p class="tell-us-more">{{ formData.fit_support_approach || '—' }}</p>
          </div>
          <div class="view-field">
            <label>Experience with supporting research and innovation projects</label>
            <p class="tell-us-more">{{ formData.fit_ri_experience || '—' }}</p>
          </div>
          <div class="view-field">
            <label>Evidence of knowledge valorisation experience</label>
            <p class="tell-us-more">{{ formData.fit_knowledge_valorisation || '—' }}</p>
          </div>
          <div class="view-field">
            <label>Additional standardisation expertise outside the list of topics</label>
            <p class="tell-us-more">{{ formData.fit_additional_expertise || '—' }}</p>
          </div>
        </div>

        <!-- Q4 — AVAILABILITY, LANGUAGES AND PREFERENCES -->
        <div class="view-section">
          <h4 class="view-section-title">Availability, languages and preferences</h4>
          <div class="view-field">
            <label>Indicative availability for mentoring assignments</label>
            <p>{{ formData.availability || '—' }}</p>
          </div>
          <div class="view-field">
            <label>Preferred types of services</label>
            <div *ngIf="formData.preferred_services && formData.preferred_services.length > 0; else noServices">
              <span *ngFor="let s of formData.preferred_services" class="topic-badge">{{ s }}</span>
            </div>
            <ng-template #noServices><span class="text-muted">—</span></ng-template>
          </div>
          <div class="view-field">
            <label>Working languages</label>
            <div *ngIf="formData.working_languages && formData.working_languages.length > 0; else noLangs">
              <span *ngFor="let l of formData.working_languages" class="topic-badge">{{ l }}</span>
            </div>
            <ng-template #noLangs><span class="text-muted">—</span></ng-template>
          </div>
          <div class="view-field">
            <label>Time zone</label>
            <p>{{ formData.time_zone || '—' }}</p>
          </div>
          <div class="view-field">
            <label>Potential limitations on availability</label>
            <p class="tell-us-more">{{ formData.availability_limitations || '—' }}</p>
          </div>
        </div>

        <!-- Q5 — CV AND DECLARATIONS -->
        <div class="view-section">
          <h4 class="view-section-title">CV and declarations</h4>
          <div class="view-field">
            <label>CV</label>
            <p>
              <a *ngIf="formData.cv; else noCv" [href]="cvDownloadUrl" target="_blank" rel="noopener" class="cv-link">
                <i class="fa fa-file-pdf-o"></i> Download CV
              </a>
              <ng-template #noCv><span class="text-muted">—</span></ng-template>
            </p>
          </div>
          <div class="view-field">
            <label>Confidentiality declaration</label>
            <p>{{ formData.confidentiality_declaration ? 'Agreed' : '—' }}</p>
          </div>
          <div class="view-field">
            <label>Accuracy declaration</label>
            <p>{{ formData.accuracy_declaration ? 'Agreed' : '—' }}</p>
          </div>
          <div class="view-field">
            <label>Data protection consent</label>
            <p>{{ formData.data_protection_consent ? 'Agreed' : '—' }}</p>
          </div>
          <div class="view-field">
            <label>Public profile consent</label>
            <p>{{ formData.public_profile_consent === 'yes' ? 'Yes' : (formData.public_profile_consent === 'no' ? 'No' : '—') }}</p>
          </div>
          <div class="view-field">
            <label>Newsletter subscription</label>
            <p>{{ formData.newsletter_subscription === 'yes' ? 'Yes' : (formData.newsletter_subscription === 'no' ? 'No' : '—') }}</p>
          </div>
        </div>

      </ng-container>

      <!-- ══════════════════════════════════════════════════════════════════════
           PROJECT / MENTORING VIEW
           ══════════════════════════════════════════════════════════════════════ -->
      <ng-container *ngIf="!isEpe">

        <!-- ABOUT YOUR PROJECT -->
        <div class="view-section">
          <h4 class="view-section-title">About Your Project</h4>
          <div class="row">
            <div class="col-md-4">
              <div class="view-field">
                <label>Project Acronym</label>
                <p>{{ projectFormData.project_acronym || '—' }}</p>
              </div>
            </div>
            <div class="col-md-8">
              <div class="view-field">
                <label>Full Project Name</label>
                <p>{{ projectFormData.full_project_name || '—' }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="view-field">
                <label>Funding Programme</label>
                <p>{{ projectFormData.funding_programme || '—' }}</p>
              </div>
            </div>
            <div class="col-md-6" *ngIf="projectFormData.other_funding_programme">
              <div class="view-field">
                <label>Funding Programme (specified)</label>
                <p>{{ projectFormData.other_funding_programme }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="view-field">
                <label>Grant Agreement Number</label>
                <p>{{ projectFormData.grant_agreement || '—' }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="view-field">
                <label>Project Call / Topic ID</label>
                <p>{{ projectFormData.project_call_topic_id || '—' }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="view-field">
                <label>Project Website</label>
                <p>
                  <a *ngIf="projectFormData.project_website; else noWebsite"
                     [href]="projectFormData.project_website" target="_blank" rel="noopener">
                    {{ projectFormData.project_website }}
                  </a>
                  <ng-template #noWebsite><span class="text-muted">—</span></ng-template>
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="view-field">
                <label>Project Officer Name</label>
                <p>{{ projectFormData.project_officer_name || '—' }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- OPEN CALL TOPICS -->
        <div class="view-section">
          <h4 class="view-section-title">Open Call Topics</h4>
          <div *ngIf="topicLabels.length > 0; else noTopicsProj">
            <span *ngFor="let t of topicLabels" class="topic-badge">{{ t }}</span>
          </div>
          <ng-template #noTopicsProj><span class="text-muted">—</span></ng-template>
        </div>

        <!-- ABOUT THE SUPPORT -->
        <div class="view-section">
          <h4 class="view-section-title">About the Support</h4>
          <div class="view-field">
            <label>Information / Support requested</label>
            <div *ngIf="projectFormData.information_to_attain && projectFormData.information_to_attain.length > 0; else noInfo">
              <ul class="list-unstyled" style="margin: 0;">
                <li *ngFor="let item of projectFormData.information_to_attain" style="margin-bottom: 4px;">
                  <i class="fa fa-check" style="color: #2ecc71; margin-right: 6px;"></i>{{ item }}
                </li>
              </ul>
            </div>
            <ng-template #noInfo><span class="text-muted">—</span></ng-template>
          </div>
          <div class="view-field">
            <label>Short Project Description</label>
            <p class="tell-us-more">{{ projectFormData.project_short_description || '—' }}</p>
          </div>
          <div class="view-field">
            <label>Why is your project applying for this support?</label>
            <p class="tell-us-more">{{ projectFormData.why_the_project_applying || '—' }}</p>
          </div>
          <ng-container *ngIf="isPss">
            <div class="view-field">
              <label>What do you expect from HSbooster.eu II proposal support?</label>
              <p class="tell-us-more">{{ projectFormData.support_expectations || '—' }}</p>
            </div>
            <div class="view-field">
              <label>1-pager</label>
              <p>
                <a *ngIf="projectFormData.one_pager_file_id; else noOnePager"
                   [href]="onePagerDownloadUrl" target="_blank" rel="noopener" class="cv-link">
                  <i class="fa fa-file-pdf-o"></i> Download 1-pager
                </a>
                <ng-template #noOnePager><span class="text-muted">—</span></ng-template>
              </p>
            </div>
            <div class="view-field">
              <label>Standardisation activities mentioned in the call text</label>
              <p class="tell-us-more">{{ projectFormData.objectives_standardisation || '—' }}</p>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="view-field">
                  <label>TRL starting point</label>
                  <p>{{ projectFormData.trl_start || '—' }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="view-field">
                  <label>Expected TRL after the project</label>
                  <p>{{ projectFormData.trl_target || '—' }}</p>
                </div>
              </div>
            </div>
            <div class="view-field">
              <label>Applicable regulations</label>
              <p class="tell-us-more">{{ projectFormData.applicable_regulations || '—' }}</p>
            </div>
            <div class="view-field">
              <label>Call deadline</label>
              <p>{{ (projectFormData.call_deadline | date:'d MMMM yyyy') || '—' }}</p>
            </div>
          </ng-container>
        </div>

        <!-- AVAILABILITY & LANGUAGE (PSS) -->
        <div class="view-section" *ngIf="isPss">
          <h4 class="view-section-title">Availability and Language Preference</h4>
          <div class="row">
            <div class="col-md-6">
              <div class="view-field">
                <label>Support start</label>
                <p>{{ projectFormData.support_start || '—' }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="view-field">
                <label>Scheduling constraints</label>
                <p class="tell-us-more">{{ projectFormData.scheduling_constraints || '—' }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="view-field">
                <label>Preferred language(s)</label>
                <p>{{ projectFormData.preferred_languages || '—' }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="view-field">
                <label>Time zone</label>
                <p>{{ projectFormData.time_zone || '—' }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- STANDARDS KNOWLEDGE -->
        <div class="view-section">
          <h4 class="view-section-title">Standards Knowledge</h4>
          <div class="view-field">
            <label>Do you already know specific standards relevant to your project?</label>
            <p>{{ projectFormData.know_standards === 'yes' ? 'Yes' : 'No' }}</p>
            <p *ngIf="isPss && projectFormData.know_standards === 'yes'" class="tell-us-more">{{ projectFormData.standards_details || '—' }}</p>
          </div>
          <ng-container *ngIf="isPss">
            <div class="view-field">
              <label>Contact with a National Standardisation Body</label>
              <p>
                {{ projectFormData.nsb_contact === 'yes' ? ('Yes — ' + (projectFormData.nsb_contact_name || '—')) : 'No' }}
              </p>
            </div>
            <div class="view-field">
              <label>Knows standards relevant to the future project</label>
              <p>
                {{ projectFormData.known_standards_yn === 'yes' ? ('Yes — ' + (projectFormData.known_standards_titles || '—')) : 'No' }}
              </p>
            </div>
          </ng-container>
          <ng-container *ngIf="isPss ? (projectFormData.standard_reference && projectFormData.standard_reference.length > 0) : projectFormData.know_standards === 'yes'">
            <div *ngIf="projectFormData.standard_reference && projectFormData.standard_reference.length > 0; else noStds">
              <div *ngFor="let ref of projectFormData.standard_reference; let i = index"
                   class="entry-panel panel panel-default">
                <div class="panel-heading"><strong>Standard {{ i + 1 }}</strong></div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="view-field">
                        <label>SDO / NSB</label>
                        <p>{{ $any(ref).sdo || '—' }}</p>
                      </div>
                    </div>
                    <div class="col-md-6" *ngIf="$any(ref).other_options">
                      <div class="view-field">
                        <label>SDO (specified)</label>
                        <p>{{ $any(ref).other_options }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">
                      <div class="view-field">
                        <label>TC/SC/WG Number</label>
                        <p>{{ $any(ref).tc_number || '—' }}</p>
                      </div>
                    </div>
                    <div class="col-md-7">
                      <div class="view-field">
                        <label>TC/SC/WG Title</label>
                        <p>{{ $any(ref).tc_title || '—' }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="view-field">
                    <label>Relationship to this standard</label>
                    <p>
                      <span *ngIf="$any(ref).is_contribute">Contribute to its development</span>
                      <span *ngIf="$any(ref).is_contribute && $any(ref).is_use"> · </span>
                      <span *ngIf="$any(ref).is_use">Use / implement it</span>
                      <span *ngIf="!$any(ref).is_contribute && !$any(ref).is_use" class="text-muted">—</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noStds><span class="text-muted">No standards listed.</span></ng-template>
          </ng-container>
        </div>

        <!-- CONSENT (PROJECT) -->
        <div class="view-section">
          <h4 class="view-section-title">Consent</h4>
          <div class="view-field" *ngIf="!isPss">
            <label>Publish project information on HSBooster.eu website</label>
            <p>{{ projectFormData.website_publication ? 'Yes' : 'No' }}</p>
          </div>
          <div class="view-field">
            <label>Data processing consent</label>
            <p>{{ projectFormData.data_consent ? 'Agreed' : '—' }}</p>
          </div>
          <div class="view-field">
            <label>Accuracy declaration</label>
            <p>{{ projectFormData.accuracy_declaration ? 'Agreed' : '—' }}</p>
          </div>
        </div>

      </ng-container>

      <a routerLink="/my-applications" class="back-link">
        <i class="fa fa-arrow-left"></i> Back to My Applications
      </a>

    </ng-container>

  </div>
</div>
